
// import {fire, fireAuth} from '@/firebase/config'
import { useStore } from "vuex";
import { onMounted, ref, provide } from "vue";
import { a, n } from "@/composables/types";
import useCss from "@/composables/useCss";
import { useRouter, useRoute } from "vue-router";


// import JQuery from 'jquery'
// window.$ = JQuery

export default {
  // components: [],
  setup() {
    const ss = useStore().state;
    const router = useRouter();
    // const sg = useStore().getters;

    ///////////////////////

    ///////////css////////////
    // css import
    const { count, slide, cqueA, cque } = useCss();
    onMounted(() => {
      //elements
      ////////////////////////////////////
      const outer = cqueA(".card-item-outer");
      const slider = cque(".card-slider");
      const back = cqueA(".card-back");
      const item = cqueA(".card-item");

      //action
      //////////////////////////////////////////
      if (outer && slider && back && item) {
        //set all card-outer to 1/x width
        // console.log("mounted");
        outer.forEach(item => {
          item.style.width = `calc(100% / ${ss.cards.length})`;
        });

        //set the card-slider to x width
        slider.style.width = `${ss.cards.length * 100}%`;

        //set card-back height to card-item height
        back.forEach((it, i) => {
          // console.log(it, item[i].offsetHeight);
          let heightx = (item[i].offsetHeight)-60
          if(heightx < 470){heightx = 470}
          it.style.height = `${heightx}px`;
        });
      }
    });
    ////////////////////////
    return {
      ss,
      slide,
      count,
      router
    };
  }
};
